import React from "react";
import { Badge } from "flowbite-react";
import {
  HiOutlineCurrencyDollar,
  HiOutlineDocumentReport,
} from "react-icons/hi";
import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";

function formatCurrency(value) {
  if (!value || isNaN(value)) return "R$ 0,00";
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  });
}

export default function CadinQuery({ data }) {
  const ocorrencias = data?.ocorrencias || [];

  return (
    <div className="space-y-6">
      {data?.statusRetorno === 1 && (
        <>
          <TitleStripe>Cadin</TitleStripe>

          {ocorrencias.length > 0 ? (
            ocorrencias.map((ocorrencia, indexO) => (
              <div
                key={indexO}
                className="border border-gray-200 rounded-lg bg-white p-4 shadow-sm "
              >
                <div className="flex justify-between items-center">
                  <div>
                    <h2 className="text-base font-semibold text-gray-800">
                      {ocorrencia.nome}
                    </h2>
                    <div className="flex gap-2 items-center mt-1">
                      <span className="text-sm text-gray-500">
                        {ocorrencia.niformatado || "Sem documento"}
                      </span>
                      <Badge
                        color={
                          ocorrencia.possuiDivida === "S"
                            ? "failure"
                            : "success"
                        }
                      >
                        {ocorrencia.possuiDivida === "S"
                          ? "Possui Dívida"
                          : "Sem Dívida"}
                      </Badge>
                    </div>
                  </div>
                </div>

                <div className="text-sm text-gray-600 mt-2 mb-3 flex gap-4">
                  <span>
                    UF: <b>{ocorrencia.uf || "-"}</b>
                  </span>
                  <span>
                    Valor total informado:{" "}
                    <b>{ocorrencia.valor || "Sem informação"}</b>
                  </span>
                </div>

                {ocorrencia.dividas?.map((divida, indexD) => {
                  const totalInscricoes = divida.inscricoes?.length || 0;
                  const valorTotal = divida.inscricoes?.reduce(
                    (acc, curr) => acc + (curr?.valorDouble || 0),
                    0
                  );

                  return (
                    <div
                      key={indexD}
                      className="border-t pt-2 mt-2 border-gray-100 mb-4"
                    >
                      <div className="flex justify-between items-center mb-1">
                        <span className="font-medium text-gray-700">
                          {divida.natureza || "Natureza não informada"}
                        </span>
                        <span className="text-sm text-red-500">
                          <b>{totalInscricoes}</b> inscrições ·{" "}
                          {formatCurrency(valorTotal)}
                        </span>
                      </div>

                      <div className="grid gap-3 mt-2">
                        {divida.inscricoes?.slice(-5).map((inscricao, i) => (
                          <div
                            key={i}
                            className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-lg p-3"
                          >
                            <div className="flex items-center gap-3">
                              <div className="bg-blue-100 text-blue-600 p-2 rounded-full">
                                <HiOutlineDocumentReport className="w-5 h-5" />
                              </div>
                              <div>
                                <p className="text-sm text-gray-800 font-medium">
                                  Inscrição nº {inscricao.numero}
                                </p>
                                <p className="text-xs text-gray-500">
                                  Documento financeiro registrado
                                </p>
                              </div>
                            </div>
                            <span className="text-sm font-semibold text-gray-800">
                              {formatCurrency(inscricao.valorDouble)}
                            </span>
                          </div>
                        ))}

                        <span className="text-gray-500 text-sm">
                          Exibindo as últimas 5 ocorrências
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            ))
          ) : (
            <NoOcurrence />
          )}
        </>
      )}
    </div>
  );
}
